import {Component, input} from '@angular/core';
import {AdminPhaseStatusInfo} from '@frontend/shared-api';
import {TooltipModule} from 'primeng/tooltip';
import {PhaseBarComponent} from '../../../../../shared/components/provider/phase-bar/phase-bar.component';
import {getAdminPhaseBarColor} from '../../../../../shared/constants/provider-phase.constants';
import {ProviderStatusTableComponent} from '../provider-status-table/provider-status-table.component';

@Component({
  selector: 'app-phase-status-bars',
  templateUrl: './phase-status-bars.component.html',
  imports: [TooltipModule, PhaseBarComponent, ProviderStatusTableComponent],
})
export class PhaseStatusBarsComponent {
  phaseStatusInfos = input.required<AdminPhaseStatusInfo[]>();

  protected getPhaseColor(phaseStatusInfo: AdminPhaseStatusInfo): string {
    return getAdminPhaseBarColor(
      phaseStatusInfo.phaseLocked,
      phaseStatusInfo.providersInPhaseFinished,
      phaseStatusInfo.providersInPhaseInProgress,
    );
  }

  protected getPhaseLabel(phaseStatusInfo: AdminPhaseStatusInfo): string {
    return `${phaseStatusInfo.phase} (${phaseStatusInfo.providersInPhaseFinished}/${phaseStatusInfo.providersInPhaseInProgress}/${phaseStatusInfo.providersInPhaseFinalLost})`;
  }

  protected getPhaseTooltip(phaseStatusInfo: AdminPhaseStatusInfo): string {
    const total =
      phaseStatusInfo.providersInPhaseFinished +
      phaseStatusInfo.providersInPhaseInProgress +
      phaseStatusInfo.providersInPhaseFinalLost;
    return `(Finished: ${phaseStatusInfo.providersInPhaseFinished} / InProgress: ${phaseStatusInfo.providersInPhaseInProgress} / Lost: ${phaseStatusInfo.providersInPhaseFinalLost} / Total: ${total})`;
  }
}
